import Home from "./Pages/home/Home";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Login from "./Pages/login/Login";
import List from "./Pages/list/List";
import Single from "./Pages/updateUser/UpdateUser";
import NewHotel from "./Pages/newHotel/NewHotel"
import NewUser from "./Pages/newUser/NewUser";
import NewEvent from "./Pages/newEvent/NewEvent";
import NewPlan from './Pages/newPlan/NewPlan'
import { productInputs, userInputs } from "./formSource";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { cafeColumns, hotelColumns, userColumns, eventColumns, planColumns } from "./datatablesource";
import NewCafe from "./Pages/newCafe/NewCafe";
import UpdateHotel from "./Pages/updateHotel/UpdateHotel";
import UpdateUser from "./Pages/updateUser/UpdateUser";
import UpdateEvent from './Pages/updateEvent/UpdateEvent'
import UpdateCafe from './Pages/updateCafe/UpdateCafe'
import UpdatePlan from './Pages/updatePlan/UpdatePlan'
import ContactMessages from "./Pages/ContactMessages/ContactMessages";
import BlogList from "./Pages/blogs/BlogList";
import BlogNew from "./Pages/newBlog/NewBlog";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EditBlog from "./Pages/editBlog/EditBlog";
import ViewBlog from "./Pages/viewBlog/ViewBlog";
import AnalyticsPage from "./Pages/analytics/AnalyticsPage";
import ReviewsAdmin from "./Pages/ReviewsAdmin/ReviewsAdmin";


function App() {

  function ProtectedRoute({ children }) {
    const { user, error } = useContext(AuthContext);
    const navigate = useNavigate();

    // If session expired, redirect to login
    useEffect(() => {
      if (error && error.message === 'Session expired. Please login again.') {
        navigate('/login', { replace: true });
      }
    }, [error, navigate]);

    if (!user) {
      return <Navigate to="/login" replace />;
    }

    return children;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="login" element={<Login />} />
            <Route
              index
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />



            <Route path="users">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={userColumns} />
                  </ProtectedRoute>} />
              <Route path=":id"
                element={
                  <ProtectedRoute>
                    <UpdateUser />
                  </ProtectedRoute>
                }
              />
              <Route path="new"
                element={
                  <ProtectedRoute>
                    <NewUser inputs={userInputs} title="Add New Users" />
                  </ProtectedRoute>
                } />
            </Route>


            <Route path="cafes">
              <Route index
                element={
                  <ProtectedRoute>
                    <List columns={cafeColumns} />
                  </ProtectedRoute>
                } />

              <Route
                path=":id"
                element={
                  <ProtectedRoute>
                    <UpdateCafe />
                  </ProtectedRoute>
                }
              />

              <Route path="new"
                element={
                  <ProtectedRoute>
                    <NewCafe />
                  </ProtectedRoute>

                } />
            </Route>



            <Route path="hotels">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={hotelColumns} />
                  </ProtectedRoute>} />
              <Route path=":id"
                element={
                  <ProtectedRoute>
                    <UpdateHotel />
                  </ProtectedRoute>
                }
              />
              <Route path="new"
                element={
                  <ProtectedRoute>
                    <NewHotel />
                  </ProtectedRoute>
                } />
            </Route>


            <Route path="events">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={eventColumns} />
                  </ProtectedRoute>} />
              <Route path=":id"
                element={
                  <ProtectedRoute>
                    <UpdateEvent />
                  </ProtectedRoute>
                }
              />
              <Route path="new"
                element={
                  <ProtectedRoute>
                    <NewEvent />
                  </ProtectedRoute>
                } />
            </Route>

            <Route path="plans">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={planColumns} />
                  </ProtectedRoute>} />
              <Route path=":id"
                element={
                  <ProtectedRoute>
                    <UpdatePlan />
                  </ProtectedRoute>
                }
              />
              <Route path="new"
                element={
                  <ProtectedRoute>
                    <NewPlan />
                  </ProtectedRoute>
                } />
            </Route>


            <Route path="blogs">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <BlogList />
                  </ProtectedRoute>}
              />
              <Route path="view/:id"
                element={
                  <ProtectedRoute>
                    <ViewBlog />
                  </ProtectedRoute>
                }
              />
              <Route path=":id"
                element={
                  <ProtectedRoute>
                    <EditBlog />
                  </ProtectedRoute>
                }
              />
              <Route path="new"
                element={
                  <ProtectedRoute>
                    <BlogNew />
                  </ProtectedRoute>
                } />
            </Route>

            <Route path='/contact' element={<ContactMessages />} />

            <Route path="reviews" element={
              <ProtectedRoute>
                <ReviewsAdmin />
              </ProtectedRoute>
            } />

            <Route path="analytics/:businessType/:businessId"
              element={
                <ProtectedRoute>
                  <AnalyticsPage />
                </ProtectedRoute>
              } />


          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
